const ZoomV6 = (() => {
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => [...r.querySelectorAll(s)];
  const readJSON = (id) => {
    try { return JSON.parse(q(id)?.textContent || '{}'); } catch { return {}; }
  };

  const initLocationFilters = () => {
    qa('[data-location-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        const value = button.dataset.locationFilter;
        const root = button.closest('.zoom-locations-v6');
        qa('[data-location-filter]', root).forEach((b) => b.classList.toggle('is-active', b === button));
        qa('[data-location-card]', root).forEach((card) => { card.hidden = value !== 'all' && card.dataset.city !== value; });
      });
    });
  };

  const initTrackOrder = () => {
    qa('[data-zoom-track-form]').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const base = form.dataset.trackingUrl;
        if (!base) return;
        const data = new FormData(form);
        const url = new URL(base, window.location.origin);
        url.searchParams.set('order', String(data.get('order') || '').trim());
        url.searchParams.set('contact', String(data.get('contact') || '').trim());
        window.location.assign(url.toString());
      });
    });
  };

  const loadPrivacy = (callback) => {
    if (window.Shopify?.customerPrivacy) return callback(window.Shopify.customerPrivacy);
    if (!window.Shopify?.loadFeatures) return callback(null);
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      callback(error ? null : window.Shopify?.customerPrivacy || null);
    });
  };

  const initConsent = () => {
    const banner = q('[data-zoom-consent]');
    if (!banner) return;
    loadPrivacy((privacy) => {
      if (!privacy) return;
      const refresh = () => { banner.hidden = !privacy.shouldShowBanner(); };
      refresh();
      q('[data-zoom-consent-accept]', banner)?.addEventListener('click', () => {
        privacy.setTrackingConsent({ analytics: true, marketing: true, preferences: true }, () => { banner.hidden = true; });
      });
      q('[data-zoom-consent-reject]', banner)?.addEventListener('click', () => {
        privacy.setTrackingConsent({ analytics: false, marketing: false, preferences: true }, () => { banner.hidden = true; });
      });
    });
  };

  const initTracking = () => {
    const config = readJSON('#ZoomTrackingConfig');
    const context = readJSON('#ZoomTrackingContext');
    if (!config.enabled) return;
    window.dataLayer = window.dataLayer || [];
    const state = { gtm:false, google:false, meta:false, tiktok:false, snapchat:false };
    const pagePayload = context.product ? {
      content_ids:[String(context.product.variantId || context.product.id)],
      content_name:context.product.title,
      content_type:'product',
      value:Number(context.product.price || 0),
      currency:context.currency
    } : {};

    const emitPage = (kind) => {
      if (kind === 'meta' && window.fbq) window.fbq('track', context.pageType === 'product' ? 'ViewContent' : 'PageView', pagePayload);
      if (kind === 'tiktok' && window.ttq) context.pageType === 'product' ? window.ttq.track('ViewContent', pagePayload) : window.ttq.page();
      if (kind === 'snapchat' && window.snaptr) window.snaptr('track', context.pageType === 'product' ? 'VIEW_CONTENT' : 'PAGE_VIEW', pagePayload);
    };
    const loadScript = (src, attrs={}) => new Promise((resolve,reject) => { const s=document.createElement('script'); s.async=true; s.src=src; Object.entries(attrs).forEach(([k,v])=>s.setAttribute(k,v)); s.onload=resolve; s.onerror=reject; document.head.appendChild(s); });
    const loadGTM = () => { if (state.gtm || !config.gtm) return; state.gtm=true; window.dataLayer.push({'gtm.start':Date.now(),event:'gtm.js'}); loadScript(`https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(config.gtm)}`); };
    const loadGoogle = () => { if (state.google || !config.googleAds) return; state.google=true; window.dataLayer.push(['js', new Date()]); window.gtag=window.gtag||function(){window.dataLayer.push(arguments)}; loadScript(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(config.googleAds)}`).then(()=>window.gtag('config',config.googleAds)); };
    const loadMeta = () => { if (state.meta || !config.meta) return; state.meta=true; !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js'); window.fbq('init',config.meta); emitPage('meta'); };
    const loadTikTok = () => { if (state.tiktok || !config.tiktok) return; state.tiktok=true; !function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=['page','track','identify','instances','debug','on','off','once','ready','alias','group','enableCookie','disableCookie','holdConsent','revokeConsent','grantConsent'];ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat([].slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.load=function(e,n){var r='https://analytics.tiktok.com/i18n/pixel/events.js';ttq._i=ttq._i||{};ttq._i[e]=[];ttq._i[e]._u=r;ttq._t=ttq._t||{};ttq._t[e]=+new Date;ttq._o=ttq._o||{};ttq._o[e]=n||{};var o=d.createElement('script');o.type='text/javascript';o.async=!0;o.src=r+'?sdkid='+e+'&lib='+t;var a=d.getElementsByTagName('script')[0];a.parentNode.insertBefore(o,a)};ttq.load(config.tiktok);emitPage('tiktok')}(window,document,'ttq'); };
    const loadSnap = () => { if (state.snapchat || !config.snapchat) return; state.snapchat=true; (function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function(){a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};a.queue=[];var s='script';var r=t.createElement(s);r.async=!0;r.src=n;var u=t.getElementsByTagName(s)[0];u.parentNode.insertBefore(r,u)})(window,document,'https://sc-static.net/scevent.min.js'); window.snaptr('init',config.snapchat,{}); emitPage('snapchat'); };

    const loadAllowed = (privacy) => {
      const analyticsAllowed = !privacy || privacy.analyticsProcessingAllowed();
      const marketingAllowed = !privacy || privacy.marketingAllowed();
      if (analyticsAllowed || marketingAllowed) { loadGTM(); loadGoogle(); }
      if (marketingAllowed) { loadMeta(); loadTikTok(); loadSnap(); }
    };
    loadPrivacy((privacy) => loadAllowed(privacy));
    document.addEventListener('visitorConsentCollected', () => loadPrivacy((privacy) => loadAllowed(privacy)));

    const dispatch = (eventName, payload={}) => {
      window.dataLayer.push({event:eventName,...payload});
      if (window.fbq) { const map={zoom_add_to_cart:'AddToCart',zoom_begin_checkout:'InitiateCheckout',zoom_search:'Search'}; if(map[eventName]) window.fbq('track',map[eventName],payload); }
      if (window.ttq) { const map={zoom_add_to_cart:'AddToCart',zoom_begin_checkout:'InitiateCheckout',zoom_search:'Search'}; if(map[eventName]) window.ttq.track(map[eventName],payload); }
      if (window.snaptr) { const map={zoom_add_to_cart:'ADD_CART',zoom_begin_checkout:'START_CHECKOUT',zoom_search:'SEARCH'}; if(map[eventName]) window.snaptr('track',map[eventName],payload); }
    };
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (form instanceof HTMLFormElement && /\/cart\/add/.test(form.action || '')) dispatch('zoom_add_to_cart', pagePayload);
    }, true);
    document.addEventListener('click', (event) => {
      const checkout = event.target.closest('a[href*="/checkout"],button[name="checkout"],input[name="checkout"]');
      if (checkout) dispatch('zoom_begin_checkout',{currency:context.currency});
    }, true);
    if (context.pageType === 'search' && context.searchTerm) dispatch('zoom_search',{search_string:context.searchTerm});
  };

  const init = () => { initLocationFilters(); initTrackOrder(); initConsent(); initTracking(); };
  return { init };
})();

document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', ZoomV6.init, {once:true}) : ZoomV6.init();
